/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { special_allocations_AbsenceListResponse } from '../models/special_allocations_AbsenceListResponse';
import type { special_allocations_AbsenceResponse } from '../models/special_allocations_AbsenceResponse';
import type { special_allocations_BatchCreateGroupOverrideRequest } from '../models/special_allocations_BatchCreateGroupOverrideRequest';
import type { special_allocations_BatchCreateGroupOverrideResponse } from '../models/special_allocations_BatchCreateGroupOverrideResponse';
import type { special_allocations_CreateAbsenceRequest } from '../models/special_allocations_CreateAbsenceRequest';
import type { special_allocations_CreateExtraDaycareRequest } from '../models/special_allocations_CreateExtraDaycareRequest';
import type { special_allocations_CreateGroupOverrideRequest } from '../models/special_allocations_CreateGroupOverrideRequest';
import type { special_allocations_ExtraDaycareListResponse } from '../models/special_allocations_ExtraDaycareListResponse';
import type { special_allocations_ExtraDaycareResponse } from '../models/special_allocations_ExtraDaycareResponse';
import type { special_allocations_GroupOverrideListResponse } from '../models/special_allocations_GroupOverrideListResponse';
import type { special_allocations_GroupOverrideResponse } from '../models/special_allocations_GroupOverrideResponse';
import type { special_allocations_UpdateAbsenceRequest } from '../models/special_allocations_UpdateAbsenceRequest';
import type { special_allocations_UpdateExtraDaycareRequest } from '../models/special_allocations_UpdateExtraDaycareRequest';
import type { special_allocations_UpdateGroupOverrideRequest } from '../models/special_allocations_UpdateGroupOverrideRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SpecialAllocationsService {
    /**
     * List absences
     * List absences with pagination and optional filters (child_id, from_date, to_date)
     * @param limit Limit
     * @param offset Offset
     * @param childId Filter by child ID
     * @param fromDate Filter absences from this date (RFC3339 format)
     * @param toDate Filter absences to this date (RFC3339 format)
     * @returns special_allocations_AbsenceListResponse OK
     * @throws ApiError
     */
    public static getApiV1Absences(
        limit: number = 50,
        offset?: number,
        childId?: string,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<special_allocations_AbsenceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/absences',
            query: {
                'limit': limit,
                'offset': offset,
                'child_id': childId,
                'from_date': fromDate,
                'to_date': toDate,
            },
            errors: {
                400: `Invalid query parameters`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to list absences`,
            },
        });
    }
    /**
     * Create an absence
     * Create a new absence with validation. Supply the optional client_capture_id to make the call idempotent: a repeat by the same user with the same key and body returns the absence the first call created with 200 and Idempotent-Replayed: true, and writes nothing; the same key with another body, or while the first call still runs, answers 409 IDEMPOTENCY_CONFLICT. An absence whose last day is before the organisation's today answers 422 ABSENCE_IN_THE_PAST unless the caller is an admin or holds the capacity module (a full-day absence ends on the UTC day of to_datetime, a part-day absence on its organisation-local day).
     * @param absence Absence data
     * @returns special_allocations_AbsenceResponse Replay of an earlier create with the same client_capture_id
     * @throws ApiError
     */
    public static postApiV1Absences(
        absence: special_allocations_CreateAbsenceRequest,
    ): CancelablePromise<special_allocations_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/absences',
            body: absence,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `CHILD_NOT_FOUND`,
                409: `IDEMPOTENCY_CONFLICT`,
                422: `ABSENCE_IN_THE_PAST, or a field the service rejected (errors.<field> = invalid)`,
                500: `Failed to create absence`,
            },
        });
    }
    /**
     * Delete an absence
     * Soft-delete an absence by ID
     * @param id Absence ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Absences(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/absences/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing absence ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Absence not found`,
                500: `Failed to delete absence`,
            },
        });
    }
    /**
     * Get an absence
     * Get an absence by ID
     * @param id Absence ID
     * @returns special_allocations_AbsenceResponse OK
     * @throws ApiError
     */
    public static getApiV1Absences1(
        id: string,
    ): CancelablePromise<special_allocations_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/absences/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing absence ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Absence not found`,
                500: `Failed to get absence`,
            },
        });
    }
    /**
     * Update an absence
     * Update an existing absence with validation and optimistic locking
     * @param id Absence ID
     * @param absence Absence data
     * @returns special_allocations_AbsenceResponse OK
     * @throws ApiError
     */
    public static putApiV1Absences(
        id: string,
        absence: special_allocations_UpdateAbsenceRequest,
    ): CancelablePromise<special_allocations_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/absences/{id}',
            path: {
                'id': id,
            },
            body: absence,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Absence not found`,
                409: `Concurrent modification detected`,
                500: `Failed to update absence`,
            },
        });
    }
    /**
     * List extra daycare entries
     * List extra daycare entries with pagination and optional filters (child_id, group_id, date)
     * @param limit Limit
     * @param offset Offset
     * @param childId Filter by child ID
     * @param groupId Filter by group ID
     * @param date Filter by date (YYYY-MM-DD format)
     * @returns special_allocations_ExtraDaycareListResponse OK
     * @throws ApiError
     */
    public static getApiV1ExtraDaycare(
        limit: number = 50,
        offset?: number,
        childId?: string,
        groupId?: string,
        date?: string,
    ): CancelablePromise<special_allocations_ExtraDaycareListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/extra-daycare',
            query: {
                'limit': limit,
                'offset': offset,
                'child_id': childId,
                'group_id': groupId,
                'date': date,
            },
            errors: {
                400: `Invalid query parameters`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to list extra daycare`,
            },
        });
    }
    /**
     * Create an extra daycare entry
     * Create a new extra daycare entry with validation
     * @param extraDaycare Extra daycare data
     * @returns special_allocations_ExtraDaycareResponse Created
     * @throws ApiError
     */
    public static postApiV1ExtraDaycare(
        extraDaycare: special_allocations_CreateExtraDaycareRequest,
    ): CancelablePromise<special_allocations_ExtraDaycareResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/extra-daycare',
            body: extraDaycare,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                409: `The child already has an extra day covering that time`,
                500: `Failed to create extra daycare`,
            },
        });
    }
    /**
     * Delete an extra daycare entry
     * Soft-delete an extra daycare entry by ID
     * @param id Extra Daycare ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1ExtraDaycare(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/extra-daycare/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing extra daycare ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Extra daycare not found`,
                500: `Failed to delete extra daycare`,
            },
        });
    }
    /**
     * Get an extra daycare entry
     * Get an extra daycare entry by ID
     * @param id Extra Daycare ID
     * @returns special_allocations_ExtraDaycareResponse OK
     * @throws ApiError
     */
    public static getApiV1ExtraDaycare1(
        id: string,
    ): CancelablePromise<special_allocations_ExtraDaycareResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/extra-daycare/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing extra daycare ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Extra daycare not found`,
                500: `Failed to get extra daycare`,
            },
        });
    }
    /**
     * Update an extra daycare entry
     * Update an existing extra daycare entry with validation and optimistic locking
     * @param id Extra Daycare ID
     * @param extraDaycare Extra daycare data
     * @returns special_allocations_ExtraDaycareResponse OK
     * @throws ApiError
     */
    public static putApiV1ExtraDaycare(
        id: string,
        extraDaycare: special_allocations_UpdateExtraDaycareRequest,
    ): CancelablePromise<special_allocations_ExtraDaycareResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/extra-daycare/{id}',
            path: {
                'id': id,
            },
            body: extraDaycare,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Extra daycare not found`,
                409: `Concurrent modification detected, or the child already has an extra day covering that time`,
                500: `Failed to update extra daycare`,
            },
        });
    }
    /**
     * List group overrides
     * List group allocation overrides with pagination and optional filters (child_id, date)
     * @param limit Limit
     * @param offset Offset
     * @param childId Filter by child ID
     * @param date Filter by date (YYYY-MM-DD format)
     * @returns special_allocations_GroupOverrideListResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupOverrides(
        limit: number = 50,
        offset?: number,
        childId?: string,
        date?: string,
    ): CancelablePromise<special_allocations_GroupOverrideListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/group-overrides',
            query: {
                'limit': limit,
                'offset': offset,
                'child_id': childId,
                'date': date,
            },
            errors: {
                400: `Invalid query parameters`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to list group overrides`,
            },
        });
    }
    /**
     * Create a group override
     * Create a new group allocation override with validation
     * @param groupOverride Group override data
     * @returns special_allocations_GroupOverrideResponse Created
     * @throws ApiError
     */
    public static postApiV1GroupOverrides(
        groupOverride: special_allocations_CreateGroupOverrideRequest,
    ): CancelablePromise<special_allocations_GroupOverrideResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/group-overrides',
            body: groupOverride,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                500: `Failed to create group override`,
            },
        });
    }
    /**
     * Delete a group override
     * Soft-delete a group allocation override by ID
     * @param id Group Override ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1GroupOverrides(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/group-overrides/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing group override ID`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Group override not found`,
                500: `Failed to delete group override`,
            },
        });
    }
    /**
     * Get a group override
     * Get a group allocation override by ID
     * @param id Group Override ID
     * @returns special_allocations_GroupOverrideResponse OK
     * @throws ApiError
     */
    public static getApiV1GroupOverrides1(
        id: string,
    ): CancelablePromise<special_allocations_GroupOverrideResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/group-overrides/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing group override ID`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Group override not found`,
                500: `Failed to get group override`,
            },
        });
    }
    /**
     * Update a group override
     * Update an existing group allocation override with validation and optimistic locking
     * @param id Group Override ID
     * @param groupOverride Group override data
     * @returns special_allocations_GroupOverrideResponse OK
     * @throws ApiError
     */
    public static putApiV1GroupOverrides(
        id: string,
        groupOverride: special_allocations_UpdateGroupOverrideRequest,
    ): CancelablePromise<special_allocations_GroupOverrideResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/group-overrides/{id}',
            path: {
                'id': id,
            },
            body: groupOverride,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Group override not found`,
                409: `Concurrent modification detected`,
                500: `Failed to update group override`,
            },
        });
    }
    /**
     * Create multiple group overrides
     * Create multiple group allocation overrides in a single request. Partial failures are tolerated.
     * @param overrides Batch group override data
     * @returns special_allocations_BatchCreateGroupOverrideResponse Created
     * @throws ApiError
     */
    public static postApiV1GroupOverridesBatch(
        overrides: special_allocations_BatchCreateGroupOverrideRequest,
    ): CancelablePromise<special_allocations_BatchCreateGroupOverrideResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/group-overrides/batch',
            body: overrides,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                500: `Failed to process batch request`,
            },
        });
    }
}
